// extracted by mini-css-extract-plugin
export var active = "navigation-module--active--d60f0";
export var appBadgesWrapper = "navigation-module--appBadgesWrapper--97602";
export var appDownloadButton = "navigation-module--appDownloadButton--f086a";
export var brand = "navigation-module--brand--60722";
export var dropdownMenu = "navigation-module--dropdownMenu--c6766";
export var dropdownMenuContent = "navigation-module--dropdownMenuContent--ae26d";
export var groupLevelLink = "navigation-module--groupLevelLink--6aeeb";
export var hamburgerAndLogo = "navigation-module--hamburgerAndLogo--b3bd2";
export var hamburgerButton = "navigation-module--hamburgerButton--4b144";
export var hideable = "navigation-module--hideable--29438";
export var lightBg = "navigation-module--lightBg--699ca";
export var linkWithDropdown = "navigation-module--linkWithDropdown--d491e";
export var links = "navigation-module--links--93cb0";
export var menuGroup = "navigation-module--menuGroup--6b62b";
export var menuGroupTitle = "navigation-module--menuGroupTitle--47479";
export var menuGroupWrapper = "navigation-module--menuGroupWrapper--5708b";
export var menuGroups = "navigation-module--menuGroups--d91b3";
export var menuVisible = "navigation-module--menuVisible--af251";
export var mobileLinks = "navigation-module--mobileLinks--d449a";
export var mobileMenu = "navigation-module--mobileMenu--3df15";
export var mobileMenuHeader = "navigation-module--mobileMenuHeader--30c59";
export var mobileNavigation = "navigation-module--mobileNavigation--ce0e1";
export var nestedMenu = "navigation-module--nestedMenu--a7179";
export var nestedMobileLinks = "navigation-module--nestedMobileLinks--2b970";
export var newHeader = "navigation-module--newHeader--05c01";
export var newHeaderWrapper = "navigation-module--newHeaderWrapper--7d171";
export var noBorder = "navigation-module--noBorder--0a463";
export var opaqueBg = "navigation-module--opaqueBg--9b3d3";
export var overlayed = "navigation-module--overlayed--f1cc3";
export var toast = "navigation-module--toast--c862a";
export var transparentHeader = "navigation-module--transparentHeader--4db95";